import React, { useEffect, useState } from 'react';
import axiosRestaurantInstance from './AxiosRestaurantInstance'; // Import the axiosRestaurantInstance
import './css/OrderHistory.css';

const OrderHistory = () => {
    const [restaurants, setRestaurants] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState('');
    const [orders, setOrders] = useState([]);

    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user ? user.userId : null;

    // Fetch restaurants on component mount
    useEffect(() => {
        const token = localStorage.getItem('Token')
        const fetchRestaurants = async () => {
            if (!userId) {
                console.error('User ID is not available');
                return;
            }

            try {
                const response = await axiosRestaurantInstance.get(`/user_restaurant/${userId}`,{
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
                    }
                });
                console.log('Fetched restaurants:', response.data);
                if (Array.isArray(response.data)) {
                    setRestaurants(response.data);
                } else {
                    console.error('Expected an array but got:', response.data);
                }
            } catch (error) {
                console.error('Error fetching restaurants:', error);
            }
        };

        fetchRestaurants();
    }, [userId]);

    // Fetch orders based on selected restaurant
    useEffect(() => {
        const token = localStorage.getItem('Token')
        const fetchOrdersByRestaurant = async () => {
            if (!selectedRestaurant) return;

            try {
                const response = await axiosRestaurantInstance.get(`/get_orders/${selectedRestaurant}`,{
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
                    }
                });
                console.log('Fetched orders:', response.data);
                if (Array.isArray(response.data.orders)) {
                    const filteredOrders = response.data.orders.filter(order =>
                        ['CANCELLED', 'DELIVERED'].includes(order.orderStatus)
                    );
                    setOrders(filteredOrders);
                } else {
                    console.error('Expected an array but got:', response.data);
                }
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };

        fetchOrdersByRestaurant();
    }, [selectedRestaurant]);

    const handleSelectChange = (event) => {
        const restaurantId = event.target.value;
        setSelectedRestaurant(restaurantId);
        setOrders([]);
    };

    return (
        <div>
            <h3 className="order-history-heading">Order History (Cancelled & Delivered Orders)</h3>
            
            <select 
                className="order-history-select"
                value={selectedRestaurant} 
                onChange={handleSelectChange}
            >
                <option value="">-- Select a restaurant --</option>
                {restaurants.length > 0 ? (
                    restaurants.map((restaurant) => (
                        <option key={restaurant.RestaurantId} value={restaurant.RestaurantId}>
                            {restaurant.RestaurantName}
                        </option>
                    ))
                ) : (
                    <option disabled>No restaurants available</option>
                )}
            </select>

            {orders.length > 0 ? (
                <table className="order-history-table">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Customer Name</th>
                            <th>Total Price</th>
                            <th>Order Status</th>
                            <th>Created Date</th>
                            <th>Food Items</th>
                            <th>organization Name</th>
                            <th>Organization Name</th>
                            <th>Receiver Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order.orderId}>
                                <td>{order.orderId}</td>
                                <td>{order.customerName}</td>
                                <td>{order.totalPrice}</td>
                                <td>{order.orderStatus}</td>
                                <td>{order.createdDate}</td>
                                <td>
                                    {order.OrderLineItems.length > 0
                                        ? order.OrderLineItems.map(item => item.foodItemName).join(', ')
                                        : 'No food items'}
                                </td>
                                <td>{order.organizationName}</td>
                                <td>{order.receiverName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No cancelled or delivered orders found.</p>
            )}
        </div>
    );
};

export default OrderHistory;
